export enum ChangeSourceType {
  COMPONENT,
  RULESET,
  DOCUMENT_PUSH
}

export class ChangeSourceInfo {
  type?: ChangeSourceType;
  fieldName?: string;
  documentId?: string;
  controlName?: string;
  resetDocument?: boolean;
}

export class StateChangeInfo {
  resetDocument?: boolean;
  patches?: any;
  inversePatches?: any;
  changedSourceInfo?: ChangeSourceInfo;
}
